import { defineComponent as q, ref as c, reactive as U, useSlots as Z, getCurrentInstance as j, onMounted as G, onBeforeUnmount as J, computed as M, h as K, render as Q, openBlock as ee, createElementBlock as te, Fragment as oe, createElementVNode as T, mergeProps as ne, renderSlot as k, withDirectives as se, vShow as ie, nextTick as z } from "vue";
import { getFixedPositionParents as re, getMaxZIndex as le } from "./utils.mjs";
const B = 6, pe = /* @__PURE__ */ q({
  inheritAttrs: !1,
  __name: "IstPopover",
  props: {
    name: {},
    delay: { default: 0 },
    transition: {},
    width: {},
    pointer: { type: Boolean, default: !0 },
    position: { default: "bottom" }
  },
  emits: {
    show(a) {
    },
    hide(a) {
    }
  },
  setup(a, { emit: C }) {
    var P;
    const s = a, S = {
      left: [-1, 0],
      right: [1, 0],
      top: [0, 1],
      bottom: [0, -1]
    };
    let u, f = c(!1), w = c(1), y = c(""), p = [], m = U({
      left: "0",
      top: "0"
    });
    const h = Z(), R = c(), g = c(), E = C, x = ((P = j()) == null ? void 0 : P.type).__scopeId, n = document.createElement("div");
    G(() => {
      var e;
      F(g.value), (e = document.querySelector("body")) == null || e.appendChild(n), n.classList.add("ist-popup_wrapper"), n.setAttribute(x, ""), L(), n.classList.add("hide");
    }), J(() => {
      n.remove();
    });
    const Y = M(() => ["ist-popover", s.pointer && y.value]), D = M(() => {
      const e = p.length > 0, o = {
        width: `${s.width}px`,
        zIndex: w.value,
        ...m
      };
      return e && (o.position = "fixed"), o;
    }), F = (e, o) => {
      const r = (t) => {
        H(t);
      }, i = (t) => {
        O(t);
      };
      e.addEventListener("mouseenter", r), e.addEventListener("mouseleave", i), e.$popoverRemoveHoverHandlers = () => {
        e.removeEventListener("mouseenter", r), e.removeEventListener("mouseleave", i);
      };
    }, H = (e) => {
      u = setTimeout(
        () => {
          y.value = `dropdown-position-${s.position}`, f.value = !0, z(() => {
            E("show", e), z(() => {
              if (h.istPopover) {
                let o = X(e, n);
                m.left = `${o.left}px`, m.top = `${o.top}px`, L();
              }
              n.classList.remove("hide");
            });
          });
        },
        Math.max(s.delay, 0)
      );
    }, L = () => {
      if (h.istPopover) {
        const e = h.istPopover(), o = K(
          "div",
          {
            class: Y.value,
            style: D.value,
            dataPopover: s.name,
            [x]: ""
          },
          e
        );
        Q(o, n);
      }
    }, O = (e) => {
      u && clearTimeout(u), f.value && (f.value = !1, n.classList.add("hide"), E("hide", e));
    }, X = (e, o) => {
      if (e.target instanceof Element) {
        const { target: r } = e, i = S[s.position], t = r.getBoundingClientRect(), l = o.children[0].getBoundingClientRect();
        p = re(r);
        const A = e.hasOwnProperty("zIndex") ? e.zIndex : le([r, ...p]) + 1;
        w.value = A;
        let b = t.left, I = t.top;
        if (p.length === 0) {
          const V = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop, W = window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft;
          b = t.left + W, I = t.top + V;
        }
        let _ = 0.5 * (l.height + t.height), d = b - 0.5 * (l.width - t.width), N = I + t.height - _, v = i[0] * 0.5 * (l.width + t.width), $ = i[1] * _;
        return s.pointer && (v += i[0] * B, $ += i[1] * B), d < 0 && (d = 0), d + v + l.width > document.body.clientWidth && (d = document.body.clientWidth - l.width), {
          left: Math.round(d + v),
          top: Math.round(N - $)
        };
      } else
        return {
          left: 0,
          top: 0
        };
    };
    return (e, o) => (ee(), te(oe, null, [
      T("span", ne({
        ref_key: "sourceElem",
        ref: g,
        style: { display: "inline-block" }
      }, e.$attrs), [
        k(e.$slots, "default", {}, void 0, !0)
      ], 16),
      se(T("div", {
        ref_key: "dropdown",
        ref: R
      }, [
        k(e.$slots, "istPopover", {}, void 0, !0)
      ], 512), [
        [ie, !1]
      ])
    ], 64));
  }
});
export {
  pe as default
};
